import defaultsDeep from 'lodash/defaultsDeep';
import BaseConfig from './http.base-instance-config';
import { getAppVariable } from '@white-label-helper/get-app-variable';
import { getRegionVariable } from '@white-label-helper/get-region-variable';
import type { Options } from './axios-config';

const { interceptors } = BaseConfig;
const baseURL = `${getRegionVariable('domains.loyalty')}/v1`;

interface LoyaltyInstance extends Options {
  baseURL: string | undefined;
}

const options: LoyaltyInstance = defaultsDeep(
  {
    baseURL,
    headers: {
      Authorization: `Bearer ${getAppVariable('channel.token')}`,
    },
  },
  BaseConfig.options,
);

export default {
  interceptors,
  options,
};
